<template>
  <div class="sidebar-container">
    <el-menu
      mode="vertical"
      router
      @select="handleSelect"
      background-color="#E9E9EA"
      text-color="#777"
      :default-active="$route.path"
      :default-openeds="openList"
      >
      <sidebar-item v-for="menu in menuList" :key="menu.number" :item="menu" />
    </el-menu>
  </div>
</template>
<script>

import SidebarItem from './SidebarItem'

export default {
  name:'Sidebar',
  components: { SidebarItem },
  props:{
    menuList: {
      type: Array,
      required: true
    }
  },
    data(){
      return{
          openList:[]
      }
    },
    watch:{
      menuList(){
          this.menuList.forEach(v=>{
              this.openList.push(v.number);
          });
      }
    },
  methods:{
      handleSelect: function (key, keyPath) {
          if (this.$route.path == key) {
              this.$nextTick(() => {
                  this.$router.replace('/managePage/emptyPage');
              })
          }
      },
  }
}
</script>
<style lang="scss">


</style>



// WEBPACK FOOTER //
// src/components/common/SideBar.vue